// extracted by mini-css-extract-plugin
export default {"main":"styles_main__PvBem","closed":"styles_closed__hpche","hovered":"styles_hovered__8S6LP"};